import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getStorageQuota } from 'state/actions'

import {
	getAccountProjects
} from 'state/selectors'

import { 
	isStandardAndNotEarlyAdopter,
	getTotalAvailableStorage
} from 'utils'

class StatusProgress extends Component {
	state = {
		hasMounted: false,
		totalUsed: 0,
		loading: false
	}

	UNSAFE_componentWillMount = _ => {
		this.getQuotaData()
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				hasMounted : true
			})
		},1)
	}

	UNSAFE_componentWillUpdate = nextProps => {
		if(!this.props.account){
			return
		}

		if(this.props.account.id !== nextProps.account.id){
			this.getQuotaData(nextProps)
		}
	}

	getQuotaData = (props = this.props) => {
		const {
			account,
			getStorageQuota
		} = props

		if(account){
			this.setState({
				loading: true
			})

			getStorageQuota(account.id, sizeInMb => {
				this.setState({
					totalUsed: sizeInMb,
					loading: false
				})
			})
		}
	}

	getTotalProjects = _ => {
		const {
			accountProjects
		} = this.props

		let count = 0

		accountProjects.forEach(project => {
			if(project && !project.deleted_at){
				count++
			}
		})

		return count
	}

	render() {
		const {
			type,
			account
		} = this.props

		const {
			hasMounted,
			totalUsed,
			loading
		} = this.state

		let copy = 'One sec...'
		let percentUsed = 0
		let startLabel = ''
		let endLabel = ''
		let middleLabel = ''

		if(type == 'storage'){
			const totalStorage = getTotalAvailableStorage(account)

			const usageInGb = Math.round((totalUsed/1000) * 100) / 100

			startLabel = '0GB'
			endLabel = totalStorage+'GB'

			percentUsed = usageInGb > 1 ? (Math.round((usageInGb && totalStorage) ? (usageInGb/totalStorage) * 100 : 0)) : 0

			if(!loading){
				if(totalUsed == 0){
					copy = `You haven't uploaded anything yet.`
				}else if(percentUsed == 0){
					copy = `You've uploaded barely anything so far!`
				}else{
					copy = `So far, you've used <strong>${ percentUsed }%</strong> of your storage quota.`
				}
			}

			middleLabel = (usageInGb > 1 ? usageInGb : 0)+'GB'
		}else{
			startLabel = 0
			endLabel = 15

			const totalProjects = this.getTotalProjects()

			percentUsed = Math.round((totalProjects/endLabel) * 100)

			if(!isStandardAndNotEarlyAdopter(account)){
				copy = `You're an early-adopter! Enjoy unlimited projects.`
			}else if(percentUsed < 30){
				copy = `You've got a bit of a way to go.`
			}else if(percentUsed < 50){
				copy = `You've used nearly half your active projects.`
			}else if(percentUsed < 75){
				copy = `You've used ${percentUsed}% of your active projects`
			}else if(percentUsed < 100){
				copy = `You're nearly full! Contact us for assistance!`
			}else{
				copy = ''
			}

			middleLabel = totalProjects
		}
		
		let containerClassName = "dateprogress-container"

		if(loading){
			containerClassName += ' loading'
		}

		return (
			<div className="widget box">
				<h3>
					{ type == 'storage' ? 'File storage' : 'Active Projects' }
				</h3>
				<p dangerouslySetInnerHTML={{ __html: copy }} />
				<div className={containerClassName}>
					<div className="dateprogress-bar big">
						<div style={{width: (hasMounted ? percentUsed : '0')+'%'}} />
					</div>
					<label
						className={percentUsed < 12 ? 'hidden' : null}
					>
						{ startLabel }
					</label>
					<label style={{left: (percentUsed < 100 ? percentUsed : 100)+'%'}}>
						{ middleLabel }
					</label>
					<label
						className={percentUsed > 89 ? 'hidden' : null}
					>
						{ endLabel }
					</label>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		accountProjects: getAccountProjects(state)
	}
}

export default connect(mapStateToProps, {
	getStorageQuota
})(StatusProgress)